import { EditOutlined, FileTextOutlined } from "@ant-design/icons";
import { Button, Descriptions } from "antd";
import { useState } from "react";
import { useLoaderData, useNavigate, useRouteLoaderData } from "react-router";
import BackTitle from "../common/BackTitle";
import { date2locale } from "../common/common";
import PdfViewer from "../common/PdfViewer";

export default function AppointmentDetails() {
  const appointment = useRouteLoaderData("appointment");
  const navigate = useNavigate();
  const [openDocument, setOpenDocument] = useState(false);

  return (
    <>
      <BackTitle
        title={appointment.appointmentType?.name ?? `Nomina #${appointment.id}`}
        extra={<Button icon={<EditOutlined />} onClick={() => navigate("edit")}>Modifica</Button>}
      />
      <Descriptions layout="vertical" colon={false} column={{ xs: 1, sm: 2, md: 3 }} items={[
        { key: "id", label: "ID", children: appointment.id },
        { key: "type", label: "Categoria", children: appointment.appointmentType?.name },
        { key: "employee", label: "Dipendente", children: appointment.employee?.fullName },
        { key: "date", label: "Data", children: appointment.date ? date2locale(appointment.date) : "—" },
        {
          key: "document", label: "Documento", children: appointment.ref ? (
            <Button icon={<FileTextOutlined />} onClick={() => setOpenDocument(true)}>Visualizza documento</Button>
          ) : "—",
        },
      ]} />
      <PdfViewer url={openDocument ? `/appointment/${appointment.id}/file` : null} onClose={() => setOpenDocument(false)} />
    </>
  );
}
